import React from "react";
import styles from "./ContactPromptSection.module.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const highlightPhrase = (text) => {
  const phrase = "Beauty & Brilliant";
  const idx = text.indexOf(phrase);
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <span className={styles.highlightBeautyBrilliant}>{phrase}</span>
      {text.slice(idx + phrase.length)}
    </>
  );
};

const ContactPromptSection = ({ text }) => {
  const navigate = useNavigate();
  return (
    <motion.section
      className={styles.contactPromptSection}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, type: "spring", stiffness: 60 }}
    >
      <div className={styles.contactPromptContent}>
        <motion.h2
          className={styles.contactPromptTitle}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {highlightPhrase(text)}
        </motion.h2>
        <motion.button
          className={styles.contactPromptButton}
          type="button"
          onClick={() => navigate("/contact")}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.25 }}
        >
          CONTACT US
        </motion.button>
      </div>
    </motion.section>
  );
};

export default ContactPromptSection;
